import React from 'react'
import { useParams } from 'react-router-dom'
import { LoaderSwitcher } from './LoaderSwitcher'
import { PARTNER_SLUGS } from 'components/Integrations/constants'
import { LightspeedBusinessesLoader } from './LightspeedBusinessesLoader'
import { LightspeedStoresLoader } from './LightspeedStoresLoader'
import { ShipdayIntegrationsLoader } from './ShipdayIntegrationsLoader'

interface PartnerDataLoadersProps {
  isParentLoaded: boolean
  children: React.ReactElement
}

const PartnerDataLoaders = ({
  isParentLoaded,
  children
}: PartnerDataLoadersProps) => {
  const { slug } = useParams()

  if (slug === PARTNER_SLUGS.LIGHTSPEED) {
    return (
      <LightspeedBusinessesLoader isParentLoaded={isParentLoaded}>
        {(isLoaded) => (
          <LightspeedStoresLoader isParentLoaded={isLoaded}>
            {(isLoaded) => (
              <LoaderSwitcher isParentLoaded={isLoaded}>
                {children}
              </LoaderSwitcher>
            )}
          </LightspeedStoresLoader>
        )}
      </LightspeedBusinessesLoader>
    )
  }

  if (slug === PARTNER_SLUGS.SHIPDAY) {
    return (
      <ShipdayIntegrationsLoader isParentLoaded={isParentLoaded}>
        {(isLoaded) => (
          <LoaderSwitcher isParentLoaded={isLoaded}>{children}</LoaderSwitcher>
        )}
      </ShipdayIntegrationsLoader>
    )
  }

  return (
    <LoaderSwitcher isParentLoaded={isParentLoaded}>{children}</LoaderSwitcher>
  )
}

export default PartnerDataLoaders
